import React from 'react'
import { any, async, fromJSX, Updater, Widget } from 'widgets-for-react'
import {
  MagazinesOverviewPageState,
  magazinesOverviewStateUpdaters
} from './magazinesOverviewState'
import { ArticlePage } from '../cmsPage/cmsPageState'
import { PageResult } from '../cmsPage/sharepointPageApi/types/pageData'
import { MagazinesOverviewLayout } from './magazinesOverviewLayout'
import { PaginationLayout } from '../../pagination/paginationLayout'

export const magazinesOverviewWidget = (
  state: MagazinesOverviewPageState
): Widget<Updater<MagazinesOverviewPageState>> => {

  return any([
    async<ArticlePage[]>(state.featuredArticles).map(
      magazinesOverviewStateUpdaters.updatefeaturedArticles
    ),
    async<ArticlePage[]>(state.semiFeaturedArticles).map(
      magazinesOverviewStateUpdaters.updateSemiFeaturedArticles
    ),
    async<PageResult<ArticlePage>>(
      state.regularArticles.regularArticlesResult
    ).map(magazinesOverviewStateUpdaters.updateRegularArticlesResult),
    fromJSX(() => {
      if (state.featuredArticles.kind === 'loaded' && state.semiFeaturedArticles.kind === 'loaded' && state.regularArticles.regularArticlesResult.kind === 'loaded') {
        return <>
          <MagazinesOverviewLayout
            featuredArticles={state.featuredArticles.value}
            semiFeaturedArticles={state.semiFeaturedArticles.value}
            regularArticles={state.regularArticles.regularArticlesResult.value.Resources}
          />
          <PaginationLayout
            currentPage={state.regularArticles.page || 1}
            totalPages={Math.ceil(
              (state.regularArticles.regularArticlesResult.value.Total) /
              state.regularArticles.regularArticlesResult.value.PerPage
            )}
            toPage={page =>
              `${location.pathname}?${new URLSearchParams({
                page: page.toString()
              }).toString()}`
            }
          />
        </>
      }
      else return <></>
    }
    )
  ])
}
